import axios, { isAxiosError, type AxiosError } from 'axios';

function formatAxiosRequestLine(err: AxiosError): string | null {
  const cfg = err.config;
  if (cfg == null) {
    return null;
  }
  const method = (cfg.method ?? 'get').toUpperCase();
  try {
    const uri = axios.getUri(cfg);
    return `${method} ${uri}`;
  } catch {
    const url = cfg.url ?? '';
    const base = (cfg.baseURL ?? '').replace(/\/$/, '');
    const path = url.replace(/^\//, '');
    const joined = url.startsWith('http') ? url : base ? `${base}/${path}` : url;
    return joined ? `${method} ${joined}` : `${method} (URL неизвестен)`;
  }
}

function axiosResponseBodyMessage(err: AxiosError): string {
  const d = err.response?.data;
  if (d != null && typeof d === 'object' && 'message' in d) {
    const msg = (d as { message: unknown }).message;
    if (typeof msg === 'string' && msg.trim()) {
      return msg.trim();
    }
  }
  if (typeof d === 'string' && d.trim()) {
    return d.trim();
  }
  if (err.response?.status != null) {
    const st = err.response.status;
    const txt = err.response.statusText?.trim();
    return txt ? `HTTP ${st} ${txt}` : `HTTP ${st}`;
  }
  return err.message?.trim() || 'Ошибка сети';
}

/**
 * Строка для пользователя из произвольного значения catch (Error, Axios, строка, объект Bitrix и т.д.).
 * Для Axios сначала разбирается запрос (метод + URL), чтобы в журнале было видно, что именно упало.
 */
export function formatUnknownError(e: unknown): string {
  if (typeof e === 'string') {
    return e.trim() || 'Неизвестная ошибка';
  }
  // AxiosError наследует Error — проверять isAxiosError до instanceof Error
  if (isAxiosError(e)) {
    const reqLine = formatAxiosRequestLine(e);
    const body = axiosResponseBodyMessage(e);
    if (reqLine) {
      return `${reqLine}\n${body}`;
    }
    return body;
  }
  if (e instanceof Error) {
    const m = e.message?.trim();
    return m || e.name || 'Ошибка';
  }
  if (e && typeof e === 'object' && 'message' in e) {
    const msg = (e as { message: unknown }).message;
    if (typeof msg === 'string' && msg.trim()) {
      return msg.trim();
    }
  }
  try {
    const s = JSON.stringify(e);
    return s === undefined ? 'Неизвестная ошибка' : s;
  } catch {
    return String(e);
  }
}
